import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { toast } from 'react-toastify';
import irelandApi from '../irelandApi';
import store from '../store';

function tokenValid(token) {
  try {
    return jwtDecode(token).exp > Math.round(new Date().getTime() / 1000);
  } catch (error) {
    toast.error('Invalid JWT token provided');
    return false;
  }
}

export function clear(tokenName = 'accessToken') {
  localStorage.removeItem(tokenName);
  delete irelandApi.defaults.headers.common.Authorization;
  delete axios.defaults.headers.common.Authorization;
}

export default function setAuthorizationToken(token, name = 'accessToken') {
  if (token) {
    localStorage.setItem(name, token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    clear();
  }
}

export const getAuthorizationToken = () => localStorage.getItem('accessToken');

export function check(token) {
  const theToken = token || getAuthorizationToken();
  if (!theToken) return false;
  return theToken && tokenValid(theToken);
}

export function isLoggedIn() {
  const token = getAuthorizationToken();
  return token && check(token) && jwtDecode(token).scp !== 'pending_user';
}

export function isRepLoggedIn() {
  const token = getAuthorizationToken();
  const { viewConfig } = store.getState();
  if (token && check(token) && viewConfig.isRep && !viewConfig.isAdmin) {
    if (viewConfig.profile.attributes['pseudo-login'] &&
        (viewConfig.profile.attributes['user-group'] === 'owner' || viewConfig.profile.attributes['user-group'] === 'staff')) {
      return false;
    }
    return true;
  }
  return false;
}

export function isAdminLoggedIn() {
  const token = getAuthorizationToken();

  return token && check(token) && store.getState().viewConfig.isAdmin;
}

export function isAuditorLoggedIn() {
  const { viewConfig } = store.getState();

  if (viewConfig.profile.attributes['pseudo-login'] && (viewConfig.profile.attributes['user-group'] === 'savi_auditor')) {
    return true;
  }
  return false;
}

export function isRdrPseudoLoggedIn() {
  const token = getAuthorizationToken();
  const { viewConfig } = store.getState();
  if (token && check(token)) {
    if (viewConfig.profile.attributes['pseudo-login'] &&
      (viewConfig.profile.attributes['original-user-group'] === 'rdr')) {
      return true;
    }
  }
  return false;
}

export function isAbmPseudoLoggedIn() {
  const token = getAuthorizationToken();
  const { viewConfig } = store.getState();
  if (token && check(token)) {
    if (viewConfig.profile.attributes['pseudo-login'] &&
      (viewConfig.profile.attributes['original-user-group'] === 'abm')) {
      return true;
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/tokenUtils.js